<template>
  <div class="wrapper pa-4">
    <portal to="app-header">
      <div class="d-flex">
        <v-spacer />

        <v-menu
          allow-overflow
          attach
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon
                color="accent"
                v-text="'mdi-translate'"
              />
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item-group
              color="primary"
            >
              <v-list-item
                v-for="(item, i) in $i18n.availableLocales"
                :key="i"
                @click="$i18n.locale = item"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="$t(`default.${item}`)" />
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      </div>
    </portal>
    <img
      class="full-bleed-img"
      src="https://cdn.jsdelivr.net/gh/miloweimo/blogimage/fzhr.jpg"
      alt="题图"
    >
    <h1>{{ $t('default.homePage') }}</h1>
    <p>
      <a 
        v-for="item,key in sortedNav"
        :key="key"
        class="mr-2"
        :href="`${item.href || '#'+item.linkto}`"
      >
        {{ item.title }}
      </a>
    </p>

    <h2>{{ $t('default.about') }}</h2>
    <p>😆</p>
    <p>
      {{ $t('default.homePage') }}: 
      <a href="https://miloweimo.github.io/#/">https://miloweimo.github.io/#/</a>
    </p>
    <p>
      {{ $t('default.repolink') }}: 
      <a href="https://github.com/miloweimo/demo/">https://github.com/miloweimo/demo/</a>
    </p>
    <p>
      {{ $t('default.deploymentProgress') }}: 
      <a href="https://github.com/miloweimo/demo/deployments">https://github.com/miloweimo/demo/deployments</a>
    </p>
    <p>{{ $t('default.currentVersion') }}: {{ VUE_APP_VERSION }}</p>
  </div>
</template>

<script>
import {navModules} from "@/modules";

export default {
  data() {
    return {
      navModules,
      VUE_APP_VERSION: process.env.VUE_APP_VERSION,
    };
  },

  computed: {
    sortedNav() {
      const list = [ ...this.navModules ];
      return list.sort((a, b) => a.title.localeCompare(b.title));
    },
  },

  created() {
    console.log(process.env);
  }
}
</script>

<style scoped>
.pointer-hover {
  /* 其他样式 */
  cursor: pointer;
}

.pointer-hover:hover {
  /* 悬浮时的样式 */
  cursor: pointer;
}

.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

.full-bleed-img {
  width: 100%;
  grid-column: 1 / -1;
  max-height: 40vh;
  object-fit:cover;
}

a {
  word-break: break-all;
}

</style>